import ABCyaPhaser from '@abcya/abcya_phaser';
import ABCyaLib from '@abcya/abcya_lib';
import Phaser from 'phaser';
import CrumblePiece from '../sprites/CrumblePiece';
import PlayerFuzzbug from '../fbhop/PlayerFuzzbug';
import gameData from '../gameData';
import { playTitleJingle } from '../SoundManager';
import SensorBar from '../fbhop/SensorBar';
import EmitterManager from '../fbhop/EmitterManager';
import InstructionScene from './InstructionScene';

export default class TitleScene extends Phaser.Scene {
  static get KEY() { return 'TitleScene'; }

  constructor() {
    super({ key: TitleScene.KEY });
  }

  init() {
    this.jumpSound = ABCyaPhaser.Audio.createSound(this);
    this.crumbleSound = ABCyaPhaser.Audio.createSound(this);
    this.propellerSound = ABCyaPhaser.Audio.createSound(this);
    this.titleSound = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

    this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => {
      this.jumpSound.destroy();
      this.crumbleSound.destroy();
      this.propellerSound.destroy();
      this.titleSound.destroy();
    });
  }

  create() {
    this.physics.world.checkCollision.up = false;
    this.physics.world.checkCollision.down = false;

    this.bg = ABCyaPhaser.Images.addImage(0,0, 'bg', this).setOrigin(0);
    this.bgOverlay = ABCyaPhaser.Images.addImage(0, 0,'background_overlay', this).setOrigin(0);
    this.bg.displayWidth = this.scale.width;
    this.bg.displayHeight = this.scale.height;

    this.title = ABCyaPhaser.Images.addImage(this.scale.width / 2, 200, 'fuzztitle', this, ABCyaPhaser.Images.LOCALIZATION_ATLAS);

    this.subtitle = this.add.bitmapText(this.scale.width / 2, 500, 'questionFont', ABCyaPhaser.Localization.instance.getLocalizedString('title'), 94, Phaser.GameObjects.BitmapText.ALIGN_CENTER).setOrigin(0.5)
      .setLetterSpacing(5)
      .setTintFill(0xF7EFDF);

    this.titlePlatform = ABCyaPhaser.Images.addImage(0, -662, 'title_platform', this).setOrigin(0);
    this.titlePlatform.x = (this.scale.width / 2) - (this.titlePlatform.width / 2);

    this.subtitle.y = this.titlePlatform.y - this.subtitle.height;
    this.title.y = this.subtitle.y - this.title.height / 2 - this.subtitle.height;

    if (ABCyaLib.Environment.instance.locale === ABCyaLib.Environment.LOCALES.esUS) {
      this.topTitle = this.add.bitmapText(this.scale.width / 2, this.title.y - this.title.height / 2 - 100, 'questionFont', ABCyaPhaser.Localization.instance.getLocalizedString('title_top'), 94, Phaser.GameObjects.BitmapText.ALIGN_CENTER).setOrigin(0.5)
        .setLetterSpacing(5)
        .setTintFill(0xF7EFDF);
    }

    this.platformGroup = this.add.container();
    this.tlPlatform = ABCyaPhaser.Images.addImage(50, 216, 'medium_platform', this.platformGroup).setOrigin(0);
    this.trPlatform = ABCyaPhaser.Images.addImage(570, 130, 'small_platform', this.platformGroup).setOrigin(0);
    this.blPlatform = ABCyaPhaser.Images.addImage(22, 854, 'small_platform', this.platformGroup).setOrigin(0);
    this.brPlatform = ABCyaPhaser.Images.addImage(512, 480, 'crumble_platform', this.platformGroup).setOrigin(0);

    this.crumbleGroup = this.add.container();
    for (let i = 0; i < 12; i++) {
      const item = new CrumblePiece(this, 0, 0, this.crumbleGroup);
    }

    this.hat = ABCyaPhaser.Images.addImage(0, this.blPlatform.y - this.blPlatform.height - 10, 'hat_animation/0000', this).setOrigin(0);
    this.hat.x = this.blPlatform.x + this.blPlatform.width / 2 - this.hat.width / 2;
    this.platformGroup.add(this.hat);

    this.introBug = new PlayerFuzzbug(this, 600, -80);
    this.introBug.toggleUsingPhysics(false);
    this.introBug.zeroFuzzMovement();
    this.add.existing(this.introBug);

    this.titleSensor = new SensorBar(this, 0, -90);
    this.add.existing(this.titleSensor);

    this.sceneParticles = new EmitterManager(this);

    this.titlePlayed = false;
    this.titleState = 10;
    this.startIntro();
  }

  startIntro() {
    ABCyaPhaser.Tweens.addTween(this.platformGroup, 800, { y: { start: this.scale.height * -1, to: this.platformGroup.y } }, Phaser.Math.Easing.Quadratic.Out, () => {
      this.firstHop();
    });
  }

  firstHop() {
    this.introBug.introJumpToPoint(630, 48, this.secondHop, this);
  }

  secondHop() {
    ABCyaPhaser.Audio.playSound('Bounce', this.jumpSound);
    this.introBug.introJumpToPoint(150, 150, this.thirdHop, this, -300);
    this.introBug.spriteParts.doJump(false);
  }

  thirdHop() {
    ABCyaPhaser.Audio.playSound('Bounce', this.jumpSound);
    this.introBug.introJumpToPoint(590, 413, this.fourthHop, this, -600);
    this.introBug.spriteParts.doJump(false);
  }

  fourthHop() {
    ABCyaPhaser.Audio.playSound('Crumble', this.crumbleSound);
    this.introBug.introJumpToPoint(100, 780, this.fifthHop, this, -400);
    this.makeCrumble(this.brPlatform.x, this.brPlatform.y);
    this.sceneParticles.makeSmokePuff(this.brPlatform.x + this.blPlatform.width / 2, this.brPlatform.y + 10);
    this.introBug.spriteParts.doJump(false);
    this.brPlatform.setActive(false).setVisible(false);
  }

  makeCrumble(x, y) {
    let pieces = null;
    pieces = gameData.gameProps.pieces1;

    const len = pieces.length;
    for (let i = 0; i < len; i++) {
      /** @type {CrumblePiece} */
      const item = this.crumbleGroup.getFirst('active', false);
      const oX = pieces[i].x;
      const oY = pieces[i].y;
      if (item) {
        const vx = pieces[i].vx * 10;
        const vy = pieces[i].vy * 10;
        item.spawn(x + oX, y + oY, pieces[i].spriteId, vx, vy, 2000);
      }
      else {
        console.error('ran out of objects');
      }
    }
  }

  fifthHop() {
    ABCyaPhaser.Audio.playSound('Bounce', this.jumpSound);
    ABCyaPhaser.Audio.playSound('Propellor_Hat', this.propellerSound);
    this.hat.setActive(false).setVisible(false);
    this.introBug.collectHat({ id: 11, type: 'hat', texture: 'pinwheel_hat', offset: { x: -3, y: -56 } });
    this.introBug.lift = 0;

    this.introBug.toggleUsingPhysics(true);
    this.introBug.updateManualPosition(92, 818);

    this.titleState = 20;

    this.introBug.setPlayerGravity(600);
    this.introBug.jump(-1200);
    this.introBug.setLiftDrag(200, 200);

    ABCyaPhaser.Tweens.addTween(this.platformGroup, 900, { y: this.scale.height }, Phaser.Math.Easing.Linear);
  }

  onTitleSensorHit() {
    playTitleJingle();
    this.titleSensor.deactivate();
    this.introBug.updateManualPosition(this.scale.width / 2, this.introBug.getBodyY());
    this.introBug.setVelY(0);
    this.introBug.setPlayerGravity(800);
    this.titleState = 30;
  }

  showGo() {
    const y = 900;
    this.btnStart = this.add.container(0, y);
    ABCyaPhaser.Buttons.addSimpleButton(0, 0, 'BUTTON_quit', 'BUTTON_quitDWN', () => this.handleStartRelease(), this.btnStart, { pressAnimationConfig: null, releaseAnimationConfig: null });
    const btnStartTxt = this.add.bitmapText(0,0, 'questionFont', ABCyaPhaser.Localization.instance.getLocalizedString('buttons.start'), 46, Phaser.GameObjects.BitmapText.ALIGN_CENTER).setOrigin(0.5)
      .setTintFill(0xefa02e);
    this.btnStart.add(btnStartTxt);
    ABCyaPhaser.Text.resizeFontToFitWidth(btnStartTxt, 125, 50);

    this.btnStart.x = this.scale.width / 2;
    this.btnStart.y = y;
    this.btnStart.scale = 0;
    ABCyaPhaser.Tweens.addTween(this.btnStart, 740, { delay: 340, scale: 1, easeParams: [0.1, 0.4] }, Phaser.Math.Easing.Elastic.Out);

    if (this.propellerSound.isPlaying) {
      this.propellerSound.mute = true;
    }
  }

  async handleStartRelease() {
    this.btnStart.disableInteractive();

    if (ABCyaLib.DEVICE_INFO.desktop) {
      // cannot use motion on desktop
      gameData.config.hasMotionControls = false;
    }
    else if (window.DeviceMotionEvent) {
      if (typeof DeviceMotionEvent.requestPermission === 'function') {
        // iOS 13+
        const permissionState = await DeviceMotionEvent.requestPermission();
        if (permissionState === 'granted') {
          gameData.config.hasMotionControls = true;
        }
        else {
          gameData.config.hasMotionControls = false;
        }
      }
      else {
        gameData.config.hasMotionControls = true;
      }
    }

    // TODO eventually change this back once iOS and ABCyaLib Sensor class has accelerationWithGravity in it
    // gameData.config.hasMotionControls = await ABCyaLib.Sensors.instance.requestMotionPermission();

    this.scene.start(InstructionScene.KEY);
  }

  update() {
    if (this.titleState === 20) {
      this.physics.collide(this.introBug.feet, this.titleSensor, this.onTitleSensorHit, null, this);
    }
    else if (this.titleState === 30) {
      this.titlePlatform.y = this.introBug.getBodyY() - 240;

      if (this.titlePlatform.y >= 662) {
        this.titlePlatform.y = 662;
        this.titleState = 40;

        this.showGo();
      }
      else if (!this.titlePlayed && this.titlePlatform.y > 20) {
        this.titlePlayed = true;
        ABCyaPhaser.Audio.playSound('Fuzz_Bugs_Factory_Hop', this.titleSound);
      }
      this.subtitle.y = this.titlePlatform.y - this.subtitle.height;
      this.title.y = this.subtitle.y - this.title.height / 2 - this.subtitle.height;
      if (this.topTitle) {
        this.topTitle.y = this.title.y - this.title.height / 2 - 110;
      }
    }
  }
}